import axios from 'axios';
import { baseApiUrl } from '../../constants';

const instance = (history = null) => {
    const axiosInstance = axios.create({ baseURL: baseApiUrl });

    axiosInstance.interceptors.response.use(
        (response) => Promise.resolve(response),
        (error) => {
            if (axios.isCancel(error)) {
                return Promise.reject(error.message);
            } 
            
            console.log('ERROR', error);

            if (!error?.response) {
                return Promise.reject(error);
            }

            if (
                error?.response?.status === 403 ||
                error?.response?.status === 401
            ) {
                localStorage.clear();
                window.location.href = '/';

                if (history) {
                    console.log('ERROR: History', history);
                } else {
                    console.log('ERROR: window.');
                }
                return Promise.reject(error.response);
            } 
            else if(error?.response?.status === 404){
                window.location.href = '/not-found';
            }
            else {
                return Promise.reject(error.response);
            }
        }
    );

    return axiosInstance;
};

const withCredentials = () => {
    const headers:any = {};
    const token = localStorage.getItem('token');
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    } else {
        console.error('JWT NOT FOUND');
    }

    return { headers: headers };
};

export { instance, withCredentials };

